import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AskStyneChatbot from "@/components/AskStyneChatbot";
import CustomCursor from "@/components/CustomCursor";
import Preloader from "@/components/Preloader";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="bg-bg text-ink min-h-screen flex flex-col">
      <Preloader />
      <CustomCursor />
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <AskStyneChatbot />
    </div>
  );
};

export default Layout;
